export const validate = (values) => {
  let errors = {}
  if (!values.email) {
    errors.email = 'Please enter an email address.'
  } else if (
    !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i.test(
      values.email
    )
  ) {
    errors.email = 'Invalid email address.'
  }

  if (!values.password) {
    errors.password = 'Please enter a password.'
  } else if (!/^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8}/i.test(values.password)) {
    errors.password =
      'Password must contain at least eight characters with at least one upper-case, one lower-case, one number and one special character.'
  }

  if (!values.passwordConfirmation) {
    errors.passwordConfirmation = 'Please enter a password confirmation.'
  }

  if (values.password !== values.passwordConfirmation) {
    errors.passwordConfirmation = 'Passwords do not match'
  }

  if (
    !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i.test(
      values.Email
    )
  ) {
    errors.Email = 'This is not a Valid Email'
  }

  if (!values.RequestEmail) {
    if (
      !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i.test(
        values.RequestEmail
      )
    ) {
      errors.RequestEmail = 'This is not a Valid Email'
    }
  }

  if (!values.RequestPhone) {
    // if (!/^\d{3}-\d{3}-\d{4}$/i.test(values.RequestPhone)) {
    //   errors.RequestPhone = 'This is not a Valid Phone Number'
    // }
  }

  if (!values.Client) {
    errors.Client = 'Please enter client name.'
  }

  if (!values.Method) {
    errors.Method = 'Please enter a Method.'
  }

  if (!values['Checking-in']) {
    errors['Checking-in'] = 'Enter a date.'
  }
  if (!values['Checking-out']) {
    errors['Checking-out'] = 'Enter a date.'
  }

  if (!values.City) {
    errors.City = 'Enter a city.'
  }

  if (!values.State) {
    errors.State = 'Enter a state.'
  }

  if (!values.PO) {
    errors.PO = 'Your company requires you to refrence a purchase order.'
  }

  if (!values.Supervisor) {
    errors.Supervisor = 'Please provide a the name of the supervisor.'
  }

  if (!values.JobType) {
    errors.JobType = 'Enter a job type.'
  }
  if (values.cancel !== 'CANCEL') {
    errors.cancel = "Please enter 'CANCEL'"
  }

  return errors
}

export const required = (value) => {
  return typeof value === 'undefined' ? 'This field is required' : undefined
}

export const selectRequired = (value) => {
  return typeof value === 'undefined' || value === '' || value === undefined ? 'This field is required' : undefined
}

export const requiredShort = (value) => {
  return value ? undefined : 'required'
}

export const number = (value) => {
  return value && isNaN(Number(value)) ? 'Must be a number' : undefined
}

export const maxLength = (max) => (value) => {
  return value && value.length > max ? `Must be ${max} characters or less` : undefined
}

export const minLength = (min) => (value) => {
  return value && value.length < min ? `Must be at least ${min} characters` : undefined
}

export const maxValue = (max) => (value) => {
  return value && value > max ? `Cannot be more than ${max}` : undefined
}

export const minValue = (min) => (value) => {
  return value && value < min ? `Cannot be < ${min}` : undefined
}

export const minValue0 = minValue(0)

export const exactLength = (length) => (value) => {
  return value && value.length !== length ? `Must be exactly ${length} characters` : undefined
}

export const phoneNumber = (value) => {
  const error = 'Invalid phone number'

  if (value === ' ' || !value) {
    return error
  }
  if (value && value.length !== 10) return error
}

export const email = (value) => {
  return value &&
    !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i.test(
      value
    )
    ? 'Invalid email address'
    : undefined
}

export const url = (value) => {
  return value && !/^(http:\/\/)?(www+\.)?[a-zA-Z0-9_-]+\.([a-zA-Z‌]{2,})+$/g.test(value) ? 'Invalid url' : undefined
}

export const currency = (value) => {
  return value && !/^-?[\d]*?(.\d{2})?$/.test(value) ? 'Invalid. Ex 10.99' : undefined
}

export const integer = (value) => {
  return value && !/^[0-9]*$/.test(value) ? 'Must be an integer' : undefined
}

export const max2Digits = (value) => {
  return value && !/^\d{1,2}$/i.test(value) ? 'Must be 2 digits or less' : undefined
}

export const match = (compareValue) => (value) => {
  return value && compareValue !== value ? 'Fields do not match' : undefined
}

// inline validators
export const inlineCurrency = (value) => {
  return (value && /^-?[\d]*?(.\d{2})?$/.test(value)) || false
}

export const inlineNumber = (value) => {
  return (value && /^[0-9]*$/.test(value)) || false
}



// WEBPACK FOOTER //
// ./src/components/Forms/Validation.jsx